export interface ExperienceFacets {
  audiences: string[];
  seasons: string[];
  durations: string[];
}

/**
 * Filter metadata for each experience slug used on the /experiences listing page.
 * Audience ids: families | children | students | professionals | travelers | culture
 * Season ids: winter | summer | monsoon
 * Duration ids: half | full | multi
 */
export const experienceFacets: Record<string, ExperienceFacets> = {
  "farmer-for-a-day": {
    audiences: ["families", "children", "travelers"],
    seasons: ["winter", "summer", "monsoon"],
    durations: ["full"],
  },
  "soil-to-plate": {
    audiences: ["families", "travelers", "professionals"],
    seasons: ["winter", "summer", "monsoon"],
    durations: ["half"],
  },
  "village-life-experience": {
    audiences: ["travelers", "culture", "families"],
    seasons: ["winter", "summer"],
    durations: ["full"],
  },
  "orchard-plantation-experiences": {
    audiences: ["travelers", "families", "professionals"],
    seasons: ["summer", "monsoon"],
    durations: ["half"],
  },
  "family-farm-experiences": {
    audiences: ["families", "children"],
    seasons: ["winter", "summer", "monsoon"],
    durations: ["half"],
  },
  "school-educational-farm-visits": {
    audiences: ["students"],
    seasons: ["monsoon", "winter"],
    durations: ["full"],
  },
  "corporate-rural-experiences": {
    audiences: ["professionals"],
    seasons: ["winter"],
    durations: ["multi"],
  },
  "rural-culture-traditions": {
    audiences: ["culture", "travelers"],
    seasons: ["monsoon", "winter"],
    durations: ["half"],
  },
};

export interface FilterOption {
  id: string;
  label: string;
  icon: string;
}

export interface FilterGroup {
  id: "audience" | "season" | "duration";
  label: string;
  icon: string;
  options: FilterOption[];
}

export const experienceFilterGroups: FilterGroup[] = [
  {
    id: "audience",
    label: "Who it's for",
    icon: "ri-group-line",
    options: [
      { id: "families", label: "Families", icon: "ri-home-heart-line" },
      { id: "children", label: "Children", icon: "ri-emotion-happy-line" },
      { id: "students", label: "Schools & Students", icon: "ri-graduation-cap-line" },
      { id: "professionals", label: "Professionals & Corporates", icon: "ri-briefcase-line" },
      { id: "travelers", label: "Travelers", icon: "ri-road-map-line" },
      { id: "culture", label: "Culture Seekers", icon: "ri-artboard-line" },
    ],
  },
  {
    id: "season",
    label: "Season",
    icon: "ri-sun-line",
    options: [
      { id: "winter", label: "Winter · Oct–Feb", icon: "ri-snowy-line" },
      { id: "summer", label: "Summer · Mar–May", icon: "ri-sun-line" },
      { id: "monsoon", label: "Monsoon · Jun–Sep", icon: "ri-rainy-line" },
    ],
  },
  {
    id: "duration",
    label: "Duration",
    icon: "ri-time-line",
    options: [
      { id: "half", label: "Half day", icon: "ri-time-line" },
      { id: "full", label: "Full day", icon: "ri-calendar-line" },
      { id: "multi", label: "Multi-day", icon: "ri-calendar-2-line" },
    ],
  },
];